<template>
  <v-card>
    <!-- Barre -->
    <v-toolbar dark color="primary">
      <v-btn icon dark @click="$emit('close')">
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>{{ $t("settings.title") }}</v-toolbar-title>
    </v-toolbar>

    <!-- Sélection du four -->
    <v-radio-group v-model="selectedOven">
      <v-list two-line subheader>
        <v-subheader>{{ $t('settings.oven_select') }}</v-subheader>

        <v-list-tile v-for="oven of ovenList" :key="oven.id" @click="selectOven(oven)">
          <v-list-tile-action>
            <v-radio :value="oven"></v-radio>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>{{ oven.name }}</v-list-tile-title>
            <v-list-tile-sub-title>{{ oven.macAddress }}</v-list-tile-sub-title>
          </v-list-tile-content>

          <v-list-tile-action>
            <v-btn icon @click.stop="editOven(oven)">
              <v-icon>edit</v-icon>
            </v-btn>
          </v-list-tile-action>
          <v-list-tile-action>
            <v-btn icon @click.stop="editUsers(oven)">
              <v-icon>face</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>

        <!-- Ajouter un four -->
        <v-list-tile @click="addOvenDialog = true">
          <v-list-tile-action>
            <v-icon>add_box</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>{{ $t('settings.add_oven') }}</v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-radio-group>

    <!--

    <v-divider></v-divider>


    <v-radio-group v-model="selectedLang">
      <v-list two-line subheader>
        <v-subheader>{{ $t('settings.lang_select') }}</v-subheader>

        <v-list-tile v-for="lang of langList" :key="lang.iso" @click="changeLang(lang.iso)">
          <v-list-tile-action>
            <v-radio :value="lang"></v-radio>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>{{ lang.name }}</v-list-tile-title>
            <v-list-tile-sub-title>{{ lang.iso }}</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-radio-group>

    -->
    <!-- Dialog d'ajout de four -->
    <v-dialog v-model="addOvenDialog" persistent max-width="600px">
      <OvenAdd @close="addOvenDialog = false"></OvenAdd>
    </v-dialog>

    <!-- Dialog d'édition / supression de four -->
    <v-dialog v-model="editOvenDialog" persistent max-width="600px">
      <OvenEdit @close="editOvenDialog = false; ovenToEdit = null" :oven="ovenToEdit"></OvenEdit>
    </v-dialog>

    <!-- Dialog d'édition des utilisateurs du four -->
    <v-dialog v-model="editOvenUsersDialog" max-width="600px">
      <OvenUsers ref="ovenUsersEdit" @close="editOvenUsersDialog = false; ovenToEdit = null" :oven="ovenToEdit">
      </OvenUsers>
    </v-dialog>
  </v-card>
</template>



<script>
import OvenAdd from "./OvenAdd";
import OvenEdit from "./OvenEdit";
import OvenUsers from "./OvenUsers";
export default {
  components: {
    OvenAdd,
    OvenEdit,
    OvenUsers
  },
  data: () => ({
    addOvenDialog: false,
    editOvenDialog: false,
    editOvenUsersDialog: false,
    ovenRadioSelect: 0,
    selectedLang: null,
    selectedOven: null,
    ovenToEdit: null,
    langList: [
      {
        iso: "fr",
        name: "Français"
      },
      {
        iso: "en",
        name: "English"
      }
    ]
  }),
  computed: {
    locale() {
      return this.$store.state.locale;
    },
    ovenList() {
      return this.$store.state.ovenList;
    },
    oven() {
      return this.$store.state.oven;
    }
  },
  watch: {
    locale() {
      this.applyLocale();
    },
    oven() {
      this.selectedOven = this.oven;
    }
  },
  methods: {
    // selectionne un four
    selectOven(oven) {
      this.$store.dispatch("selectOven", oven);
      // ferme la dialogue
      this.$emit("close");
    },

    // applique une locale
    applyLocale() {
      this.selectedLang = this.getLangFromIso(this.locale);
    },
    // édition de la config d'un four
    editOven(ovenConfig) {
      this.ovenToEdit = ovenConfig;
      this.editOvenDialog = true;
    },
    // édition des utilisateurs
    editUsers(ovenConfig) {
      this.ovenToEdit = ovenConfig;
      this.$refs["ovenUsersEdit"].loadUserList(ovenConfig.id);
      this.editOvenUsersDialog = true;
    },
    // langue depuis un code iso
    getLangFromIso(iso) {
      for (var lang of this.langList) {
        if (lang.iso == iso) {
          return lang;
        }
      }
      return null;
    },
    changeLang(langIso) {
      this.$store.dispatch("changeLang", langIso);
    }
  },
  mounted() {
    if (this.locale) {
      this.applyLocale();
    }
    if (this.oven) {
      this.selectedOven = this.oven;
    }
  }
};
</script>

<style>

</style>
